export const TESTING_DATA = {
    overViewData: {
        "total_certificates_issued": 2122,
        "total_active_certificates": 1543,
        "total_expired_certificates": 10,
        "total_cancelled_certificates": 13,
        "total_active_partners": 1044,
        "total_certificate_requests": 323458,
        "retailer_wise_summary": {
            "total": 915,
            "issued": 115,
            "not_issued": 800
        },
        "distributor_wise_summary": {
            "total": 129,
            "issued": 90,
            "not_issued": 39
        },
        "request_summary": [
            {
                "status": "Active",
                "count": 1243
            },
            {
                "status": "Cancelled",
                "count": 212
            },
            {
                "status": "Rejected",
                "count": 130
            },
            {
                "status": "Pending Delivery",
                "count": 530
            }
        ],
        "location_wise_summary": [
            {
                "location": "Anand",
                "total": 1370,
                "issued": 1000,
                "not_issued": 370
            },
            {
                "location": "Navsari",
                "total": 3180,
                "issued": 3000,
                "not_issued": 180
            },
            {
                "location": "Baroda",
                "total": 2254,
                "issued": 760,
                "not_issued": 54
            },
            {
                "location": "Bodeli",
                "total": 1216,
                "issued": 230,
                "not_issued": 116
            },
            {
                "location": "Deesa",
                "total": 1270,
                "issued": 332,
                "not_issued": 168
            },
            {
                "location": "Deesa (Tharad)",
                "total": 115,
                "issued": 80,
                "not_issued": 115
            },
            {
                "location": "Himmatnagar",
                 "total": 2180,
                "issued": 1500,
                "not_issued": 680
               
            },
            {
                "location": "Modasa",
                "total": 577,
                "issued": 100,
                "not_issued": 477
            }
        ],
        "pending_delivery_summary": {
            "total": 144,
            "not_received": 75
        }
    },
    ISSUED_SERTIFICATES: {
        "items": [
            {
                "request_id": 22,
                "created_at": "2025-11-25T11:20:29.906Z",
                "partner_id": "6184895",
                "firm_name": "test shop name",
                "due_date": "2025-12-02T00:00:00.000Z",
                "status": "Active",
                "message": "Your certificate request is approved & the PC copy has been delivered to you.",
                "certificate": {
                    "certificate_number": "499",
                    "request_id": 22,
                    "issued_date": "2025-11-25T11:21:51.027Z",
                    "expiry_date": "2025-12-30",
                    "status": "Pending Delivery"
                },
                "partner_location": "Deesa"
            },
            {
                "request_id": 21,
                "created_at": "2025-11-25T08:41:04.267Z",
                "partner_id": "GJ00480",
                "firm_name": "Testing diljith",
                "due_date": "2025-12-02T00:00:00.000Z",
                "status": "Cancelled",
                "message": "This certificate is no longer valid for use. Please contact your sales manager for more information.",
                "certificate": {
                    "certificate_number": "127845",
                    "request_id": 21,
                    "issued_date": "2025-11-25T09:35:35.354Z",
                    "expiry_date": "2025-11-25",
                    "status": "CANCELLED"
                },
                "partner_location": "Deesa"
            }
        ],
        "total": 3,
        "page": 1,
        "size": 10
    },
    PENDING_REQUESTS: {
        "items": [
            {
                "request_id": 23,
                "created_at": "2025-11-25T11:46:11.918Z",
                "partner_id": "GJ22997",
                "firm_name": "ASHIRWAD BEEJ KENDRA",
                "due_date": "2025-12-02T00:00:00.000Z",
                "status": "pending approval",
                "message": "Your application is under review",
                "partner_location": "Deesa"
            }
        ],
        "total": 3,
        "page": 1,
        "size": 10
    },
    PENDING_DELIVERY: {
        "items": [
            {
                "request_id": 23,
                "created_at": "2025-11-25T11:46:11.918Z",
                "partner_id": "GJ22997",
                "firm_name": "ASHIRWAD BEEJ KENDRA",
                "due_date": "2025-12-02T00:00:00.000Z",
                "status": "pending delivery",
                "message": "Your application is under review",
                "partner_location": "Deesa"
            }
        ],
        "total": 3,
        "page": 1,
        "size": 10
    },
    COMPLETED_REQUESTS:{
        "items": [
            {
                "request_id": 23,
                "created_at": "2025-11-25T11:46:11.918Z",
                "partner_id": "GJ22997",
                "firm_name": "ASHIRWAD BEEJ KENDRA",
                "due_date": "2025-12-02T00:00:00.000Z",
                "status": "active",
                "message": "Your application is under review",
                "partner_location": "Deesa"
            }
        ],
        "total": 3,
        "page": 1,
        "size": 10
    },
    REVIEW_REQUEST: {
        "request_id": 23,
        "created_at": "2025-11-25T11:46:11.918Z",
        "partner_id": "GJ22997",
        "govt_application_number": "",
        "gst_number": "",
        "license_number": "34567",
        "license_issued_date": "2025-11-18",
        "license_expiry_date": "2025-11-25",
        "firm_name": "ASHIRWAD BEEJ KENDRA",
        "shop_address": "test",
        "shop_district": "Mahesana",
        "shop_pincode": "345678",
        "godown_same_as_shop": false,
        "godown_address": "test1",
        "godown_district": "Anand",
        "godown_pincode": "798776",
        "assigned_to": "Ruchit Desai",
        "due_date": "2025-12-02T00:00:00.000Z",
        "status": "pending approval",
        "message": "Your request was rejected due to compliance issues.",
        "remarks": "testing the opther reasomn",
        "delivery_code": null,
        "delivery_date": null,
        "products": [
            "ACERBO"
        ],
        "license_documents": [
            {
                "document_key": "Partners/GJ22997/requests/Licences/1764071171188/download.png",
                "document_url": "https://brp-principal-certificates-web-qa.s3.ap-south-1.amazonaws.com/Partners/GJ22997/requests/Licences/1764071171188/download.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIA5CI2O5CWZO7OO6D2%2F20251201%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20251201T044132Z&X-Amz-Expires=600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjECwaCmFwLXNvdXRoLTEiRzBFAiEA4aSU%2BPl80YdAlrIIDZW134mNzmWO1n8w2QisJrw%2FcFYCIGQFOSy1%2BabJKf9CdLKKMAnrlpkd1ghacV3tqBpxSPhcKqkECPb%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMODk4MjQwNTM4Nzk3Igz19EHe%2BBumlRkY6NQq%2FQPsFgb70LjB9KSK4aj6zHvlq2XK147rc9mLhw4COtWPUzLBNOKxi6FRjxiVfwc0lapvbFLE99LyVk2y7xzbgwpfWFWZXNbMEe93zfYqj%2BV920HuqZDL%2B8wcSsZ%2BHMuJIo8ANyY6WXHwT%2FhvGq5a%2Fvkw5YeBz1gQ23%2FJBM0bclhnxPfDnyxu1F7rpYwqBgXnL1yJsnYQ8hSQtEiEjnc5sm4qE46I0G9gR6Q3dOFjEyIVfzGpE%2Fzzqb%2FFtokwlsfK4O7lcD3K1aNDNY1IBelGuV2wsqRSL9XtVeLQzbGquq6UTgw5mJUYAChGCfcRrSFFK37jNV8nWOYaHsHPNTr2LTfKmRNZ78RUbPrJ9%2BibewV7CQ8bVVwzopofTcsCn8aZtPLEsbTKpDwBwvdQw%2BLP2PsrPCSuIs6MOrQkEtPgopMpZGjxjst2uYLVXAA4FkoIuBz%2Fc35csHXEoO4C%2FDcvinnV49L%2FxpSpu2xBCWZUpR5xPMSDMyVjTpxuyORfhoEQSLJM8a38y60e9C4tek8OboOF%2FH8ocj9ujHWAi%2Bq79X0vxOwUcI%2BHjK2vRJbxgOsES8ahQdNt%2BSENFjdx3%2Fgaixtt69X%2F8XfALTaUwds2h7GE3dkIwStgSjkf1fNdCBrvNX5h0ag7MZPirCGOuA%2B%2FEzPb%2F7OcABbhkbWmzAlGtjDAsLTJBjqmAXDvdwOxomf2e7kwMKv%2Bk3aiMpQnqba9MJCYW%2BsDU77pW4sCxx%2Bl5aBurUPu7Po0qXTS1XKU%2FcGNX8VUZRgdFfKTnSE%2BYPsfpvUpl5JeGMDJLt22O%2BfE7rxFrz93yYCWr2iF8NE9ha%2Ft%2FB5duDDK8q7tBSvo5U%2B9wMy40DFXCNOtDL7hfxM3eb0KE2OjaoYAVVoa75fLFP082D5nmtbzl1BWH6cC7h4%3D&X-Amz-Signature=8c285aa9f57c804207e23918db7d54c3ea065ec8a8dc57103fee691b2689d645&X-Amz-SignedHeaders=host&x-amz-checksum-mode=ENABLED&x-id=GetObject"
            }
        ],
        "certificate_trackings": [
            {
                "step": "Request Submission",
                "status": "Done",
                "last_updated_at": "2025-11-25T11:46:11.918Z"
            },
            {
                "step": "Document Verification",
                "status": "Rejected",
                "last_updated_at": "2025-11-28T05:28:47.195Z"
            },
            {
                "step": "Certificate Delivery",
                "status": "Cancelled",
                "last_updated_at": "2025-11-28T05:28:47.227Z"
            }
        ],
        "partner_location": "INDED"
    },
    REVIEW_REQUEST_DELIVERY: {
        "request_id": 22,
        "created_at": "2025-11-25T11:20:29.906Z",
        "partner_id": "6184895",
        "govt_application_number": "",
        "gst_number": "",
        "license_number": "6129912",
        "license_issued_date": "2025-11-03",
        "license_expiry_date": null,
        "firm_name": "test shop name",
        "shop_address": "test address",
        "shop_district": "Narmada",
        "shop_pincode": "123456",
        "godown_same_as_shop": false,
        "godown_address": "test address",
        "godown_district": null,
        "godown_pincode": "123456",
        "assigned_to": "Ruchit Desai",
        "due_date": "2025-12-02T00:00:00.000Z",
        "status": "Pending Delivery",
        "message": "Your certificate request is approved & the PC copy has been delivered to you.",
        "remarks": "Certificate delivered to partner",
        "delivery_code": "7990",
        "delivery_date": "2025-11-25T11:25:38.273Z",
        "products": [
            "ACERBO",

        ],
        "license_documents": [
            {
                "document_key": "Partners/6184895/requests/Licences/1764069629071/download.png",
                "document_url": "https://brp-principal-certificates-web-qa.s3.ap-south-1.amazonaws.com/Partners/6184895/requests/Licences/1764069629071.png"
            }
        ],
        "certificate_trackings": [
            {
                "step": "Request Submission",
                "status": "Done",
                "last_updated_at": "2025-11-25T11:20:29.906Z"
            },
            {
                "step": "Document Verification",
                "status": "Done",
                "last_updated_at": "2025-11-25T11:21:51.048Z"
            },
            {
                "step": "Certificate Delivery",
                "status": "Done",
                "last_updated_at": "2025-11-25T11:25:38.282Z"
            }
        ],
        "certificate": {
            "certificate_number": "499",
            "request_id": 22,
            "partner": {
                "partner_id": "6184895",
                "name": "test shop name",
                "territory": "INDED"
            },
            "issued_date": "2025-11-25T11:21:51.027Z",
            "expiry_date": "2025-12-30T00:00:00.000Z",
            "certificate_copy_first_page_url": "https://brp-principal-certificates-web-qa.s3.ap-south-1.amazonaws.com/Partners/6184895/requests/Certificates/22/download.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIA5CI2O5CWTT5VP3VR%2F20251201%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20251201T063937Z&X-Amz-Expires=600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEC4aCmFwLXNvdXRoLTEiRzBFAiEAkhKG2bc1n2DqMNnVljEkaa8EUBnMR9bhl4yEx8H4F5wCIH11l3FfeRa5d0NTGHjvp19sXsauFS0l%2FtJLrJaArutyKqkECPj%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMODk4MjQwNTM4Nzk3IgwGTQaRJMPil19mwQoq%2FQNnI4SMRWVf96%2Bcu2wjjtaTKsUUxX7j2GlF54m5R6R6ldGvw1Qb5%2BkY7KSWboLsvEb6gCkW%2Fzaztv0Xs6zN7lFcoMHtJTWKHoHY%2FUDfuYmk8v5WUWhhB1aU1aTVLRx6OKlBRATKGteRl6K1zh2LuZVIq5i2n3YQ7Fjn30hREhoqLaiP3E3my6ncC2mjt9C6SHRnqR8RqQ1SoIwwBArxRN3UD04JwZ%2FT0lVyHxjPbjuD0kSH6wiijcCFsZLF18hMVVOet4%2Bw13wPWVcMwEjnpYRz4fZbznJr9ITvecCY6hRRB1tiDGnUV6%2FjU9lselgr3QglFcZqS3QhAPeDdF1pE4bmO9b414sYqorFeMV434e0WrbaZmo60e%2BEjb7%2BIKe7oDFLx9Y2dDD0y0%2FfM8NshqSdkRl8kCYkmiKu2WEHqHxgrm1QUBvKhTtGX4Rqo2gmbWuV%2BNtwm%2FSClo5gNbd8GY0hYHSmyBwwjNGzjHhmuTLgbQJCkC72F07FWuX%2FNipdIw51abUdGQDu0fC0jK%2FT7kwAZ28yBa0b5vcLdjgRlXI%2FwAMA5bsQncrHNRHW1%2Fh1qeY6Ev3gwyOFfEW4VeXx%2B4ZGoMQ%2FRRVJ44OlSmSfg425%2B55bKjK4Um319DuQOaH7U4Xg3%2FmvAbCJHUperkmPet25SKSVQJuA%2FbIOF%2F74njDO6bTJBjqmAW1sG8C0ckd8pDmOi1%2Fte2eE9%2B%2Bhs%2BMV%2BvESFi%2Bb3bQaLBLrMPhoxTOyyRX7TuDTzjnp9XHUfU10Fn3xMiU5Mo7fg96Jyek1DUuqL2NPBkIhIvRb8RWTG4p5l8A1VGa5%2FIxvF%2F2rBODernyis7dylUCHdIuYw0RqT%2FYOumZwIWSfnNCDvVdXWQF0mKLmlbhMlYg9Fi68zOVtjVRCtBaVmqaXoFvpmS4%3D&X-Amz-Signature=1466e50a8bf43fd1fff2ce4cb9854ffe013f8e0d4d87e624bff247ce2ed1eeef&X-Amz-SignedHeaders=host&x-amz-checksum-mode=ENABLED&x-id=GetObject%22",
            "certificate_copy_last_page_url": "https://brp-principal-certificates-web-qa.s3.ap-south-1.amazonaws.com/Partners/6184895/requests/Certificates/22/download.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIA5CI2O5CWTT5VP3VR%2F20251201%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20251201T063937Z&X-Amz-Expires=600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEC4aCmFwLXNvdXRoLTEiRzBFAiEAkhKG2bc1n2DqMNnVljEkaa8EUBnMR9bhl4yEx8H4F5wCIH11l3FfeRa5d0NTGHjvp19sXsauFS0l%2FtJLrJaArutyKqkECPj%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMODk4MjQwNTM4Nzk3IgwGTQaRJMPil19mwQoq%2FQNnI4SMRWVf96%2Bcu2wjjtaTKsUUxX7j2GlF54m5R6R6ldGvw1Qb5%2BkY7KSWboLsvEb6gCkW%2Fzaztv0Xs6zN7lFcoMHtJTWKHoHY%2FUDfuYmk8v5WUWhhB1aU1aTVLRx6OKlBRATKGteRl6K1zh2LuZVIq5i2n3YQ7Fjn30hREhoqLaiP3E3my6ncC2mjt9C6SHRnqR8RqQ1SoIwwBArxRN3UD04JwZ%2FT0lVyHxjPbjuD0kSH6wiijcCFsZLF18hMVVOet4%2Bw13wPWVcMwEjnpYRz4fZbznJr9ITvecCY6hRRB1tiDGnUV6%2FjU9lselgr3QglFcZqS3QhAPeDdF1pE4bmO9b414sYqorFeMV434e0WrbaZmo60e%2BEjb7%2BIKe7oDFLx9Y2dDD0y0%2FfM8NshqSdkRl8kCYkmiKu2WEHqHxgrm1QUBvKhTtGX4Rqo2gmbWuV%2BNtwm%2FSClo5gNbd8GY0hYHSmyBwwjNGzjHhmuTLgbQJCkC72F07FWuX%2FNipdIw51abUdGQDu0fC0jK%2FT7kwAZ28yBa0b5vcLdjgRlXI%2FwAMA5bsQncrHNRHW1%2Fh1qeY6Ev3gwyOFfEW4VeXx%2B4ZGoMQ%2FRRVJ44OlSmSfg425%2B55bKjK4Um319DuQOaH7U4Xg3%2FmvAbCJHUperkmPet25SKSVQJuA%2FbIOF%2F74njDO6bTJBjqmAW1sG8C0ckd8pDmOi1%2Fte2eE9%2B%2Bhs%2BMV%2BvESFi%2Bb3bQaLBLrMPhoxTOyyRX7TuDTzjnp9XHUfU10Fn3xMiU5Mo7fg96Jyek1DUuqL2NPBkIhIvRb8RWTG4p5l8A1VGa5%2FIxvF%2F2rBODernyis7dylUCHdIuYw0RqT%2FYOumZwIWSfnNCDvVdXWQF0mKLmlbhMlYg9Fi68zOVtjVRCtBaVmqaXoFvpmS4%3D&X-Amz-Signature=1466e50a8bf43fd1fff2ce4cb9854ffe013f8e0d4d87e624bff247ce2ed1eeef&X-Amz-SignedHeaders=host&x-amz-checksum-mode=ENABLED&x-id=GetObject%22",
            "status": "Pending Delivery"
        },
        "partner_location": "INDED",
        "distributors": "AGRI BUSINESS CENTRE"
    },
    REVIEW_REQUEST_COMPLETE:{
        "request_id": 22,
        "created_at": "2025-11-25T11:20:29.906Z",
        "partner_id": "6184895",
        "govt_application_number": "",
        "gst_number": "",
        "license_number": "6129912",
        "license_issued_date": "2025-11-03",
        "license_expiry_date": null,
        "firm_name": "test shop name",
        "shop_address": "test address",
        "shop_district": "Narmada",
        "shop_pincode": "123456",
        "godown_same_as_shop": false,
        "godown_address": "test address",
        "godown_district": null,
        "godown_pincode": "123456",
        "assigned_to": "Ruchit Desai",
        "due_date": "2025-12-02T00:00:00.000Z",
        "status": "active",
        "message": "Your certificate request is approved & the PC copy has been delivered to you.",
        "remarks": "Certificate delivered to partner",
        "delivery_code": "7990",
        "delivery_date": "2025-11-25T11:25:38.273Z",
        "products": [
            "ACERBO",

        ],
        "license_documents": [
            {
                "document_key": "Partners/6184895/requests/Licences/1764069629071/download.png",
                "document_url": "https://brp-principal-certificates-web-qa.s3.ap-south-1.amazonaws.com/Partners/6184895/requests/Licences/1764069629071.png"
            }
        ],
        "certificate_trackings": [
            {
                "step": "Request Submission",
                "status": "Done",
                "last_updated_at": "2025-11-25T11:20:29.906Z"
            },
            {
                "step": "Document Verification",
                "status": "Done",
                "last_updated_at": "2025-11-25T11:21:51.048Z"
            },
            {
                "step": "Certificate Delivery",
                "status": "Done",
                "last_updated_at": "2025-11-25T11:25:38.282Z"
            }
        ],
        "certificate": {
            "certificate_number": "499",
            "request_id": 22,
            "partner": {
                "partner_id": "6184895",
                "name": "test shop name",
                "territory": "INDED"
            },
            "issued_date": "2025-11-25T11:21:51.027Z",
            "expiry_date": "2025-12-30T00:00:00.000Z",
            "certificate_copy_first_page_url": "https://brp-principal-certificates-web-qa.s3.ap-south-1.amazonaws.com/Partners/6184895/requests/Certificates/22/download.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIA5CI2O5CWTT5VP3VR%2F20251201%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20251201T063937Z&X-Amz-Expires=600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEC4aCmFwLXNvdXRoLTEiRzBFAiEAkhKG2bc1n2DqMNnVljEkaa8EUBnMR9bhl4yEx8H4F5wCIH11l3FfeRa5d0NTGHjvp19sXsauFS0l%2FtJLrJaArutyKqkECPj%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMODk4MjQwNTM4Nzk3IgwGTQaRJMPil19mwQoq%2FQNnI4SMRWVf96%2Bcu2wjjtaTKsUUxX7j2GlF54m5R6R6ldGvw1Qb5%2BkY7KSWboLsvEb6gCkW%2Fzaztv0Xs6zN7lFcoMHtJTWKHoHY%2FUDfuYmk8v5WUWhhB1aU1aTVLRx6OKlBRATKGteRl6K1zh2LuZVIq5i2n3YQ7Fjn30hREhoqLaiP3E3my6ncC2mjt9C6SHRnqR8RqQ1SoIwwBArxRN3UD04JwZ%2FT0lVyHxjPbjuD0kSH6wiijcCFsZLF18hMVVOet4%2Bw13wPWVcMwEjnpYRz4fZbznJr9ITvecCY6hRRB1tiDGnUV6%2FjU9lselgr3QglFcZqS3QhAPeDdF1pE4bmO9b414sYqorFeMV434e0WrbaZmo60e%2BEjb7%2BIKe7oDFLx9Y2dDD0y0%2FfM8NshqSdkRl8kCYkmiKu2WEHqHxgrm1QUBvKhTtGX4Rqo2gmbWuV%2BNtwm%2FSClo5gNbd8GY0hYHSmyBwwjNGzjHhmuTLgbQJCkC72F07FWuX%2FNipdIw51abUdGQDu0fC0jK%2FT7kwAZ28yBa0b5vcLdjgRlXI%2FwAMA5bsQncrHNRHW1%2Fh1qeY6Ev3gwyOFfEW4VeXx%2B4ZGoMQ%2FRRVJ44OlSmSfg425%2B55bKjK4Um319DuQOaH7U4Xg3%2FmvAbCJHUperkmPet25SKSVQJuA%2FbIOF%2F74njDO6bTJBjqmAW1sG8C0ckd8pDmOi1%2Fte2eE9%2B%2Bhs%2BMV%2BvESFi%2Bb3bQaLBLrMPhoxTOyyRX7TuDTzjnp9XHUfU10Fn3xMiU5Mo7fg96Jyek1DUuqL2NPBkIhIvRb8RWTG4p5l8A1VGa5%2FIxvF%2F2rBODernyis7dylUCHdIuYw0RqT%2FYOumZwIWSfnNCDvVdXWQF0mKLmlbhMlYg9Fi68zOVtjVRCtBaVmqaXoFvpmS4%3D&X-Amz-Signature=1466e50a8bf43fd1fff2ce4cb9854ffe013f8e0d4d87e624bff247ce2ed1eeef&X-Amz-SignedHeaders=host&x-amz-checksum-mode=ENABLED&x-id=GetObject%22",
            "certificate_copy_last_page_url": "https://brp-principal-certificates-web-qa.s3.ap-south-1.amazonaws.com/Partners/6184895/requests/Certificates/22/download.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIA5CI2O5CWTT5VP3VR%2F20251201%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20251201T063937Z&X-Amz-Expires=600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEC4aCmFwLXNvdXRoLTEiRzBFAiEAkhKG2bc1n2DqMNnVljEkaa8EUBnMR9bhl4yEx8H4F5wCIH11l3FfeRa5d0NTGHjvp19sXsauFS0l%2FtJLrJaArutyKqkECPj%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQABoMODk4MjQwNTM4Nzk3IgwGTQaRJMPil19mwQoq%2FQNnI4SMRWVf96%2Bcu2wjjtaTKsUUxX7j2GlF54m5R6R6ldGvw1Qb5%2BkY7KSWboLsvEb6gCkW%2Fzaztv0Xs6zN7lFcoMHtJTWKHoHY%2FUDfuYmk8v5WUWhhB1aU1aTVLRx6OKlBRATKGteRl6K1zh2LuZVIq5i2n3YQ7Fjn30hREhoqLaiP3E3my6ncC2mjt9C6SHRnqR8RqQ1SoIwwBArxRN3UD04JwZ%2FT0lVyHxjPbjuD0kSH6wiijcCFsZLF18hMVVOet4%2Bw13wPWVcMwEjnpYRz4fZbznJr9ITvecCY6hRRB1tiDGnUV6%2FjU9lselgr3QglFcZqS3QhAPeDdF1pE4bmO9b414sYqorFeMV434e0WrbaZmo60e%2BEjb7%2BIKe7oDFLx9Y2dDD0y0%2FfM8NshqSdkRl8kCYkmiKu2WEHqHxgrm1QUBvKhTtGX4Rqo2gmbWuV%2BNtwm%2FSClo5gNbd8GY0hYHSmyBwwjNGzjHhmuTLgbQJCkC72F07FWuX%2FNipdIw51abUdGQDu0fC0jK%2FT7kwAZ28yBa0b5vcLdjgRlXI%2FwAMA5bsQncrHNRHW1%2Fh1qeY6Ev3gwyOFfEW4VeXx%2B4ZGoMQ%2FRRVJ44OlSmSfg425%2B55bKjK4Um319DuQOaH7U4Xg3%2FmvAbCJHUperkmPet25SKSVQJuA%2FbIOF%2F74njDO6bTJBjqmAW1sG8C0ckd8pDmOi1%2Fte2eE9%2B%2Bhs%2BMV%2BvESFi%2Bb3bQaLBLrMPhoxTOyyRX7TuDTzjnp9XHUfU10Fn3xMiU5Mo7fg96Jyek1DUuqL2NPBkIhIvRb8RWTG4p5l8A1VGa5%2FIxvF%2F2rBODernyis7dylUCHdIuYw0RqT%2FYOumZwIWSfnNCDvVdXWQF0mKLmlbhMlYg9Fi68zOVtjVRCtBaVmqaXoFvpmS4%3D&X-Amz-Signature=1466e50a8bf43fd1fff2ce4cb9854ffe013f8e0d4d87e624bff247ce2ed1eeef&X-Amz-SignedHeaders=host&x-amz-checksum-mode=ENABLED&x-id=GetObject%22",
            "status": "Pending Delivery"
        },
        "partner_location": "INDED",
        "distributors": "AGRI BUSINESS CENTRE"
    },
    ASSIGNED_CERTIFICATES:[
            {
                "booklet_id": 16,
                "issued_to": {
                    "user_id": "MBJYA",
                    "username": "Alpesh Javiya",
                    "role": "APPROVER"
                },
                "book_start_no": 100,
                "book_end_no": 500,
                "issued_date": "2025-11-25",
                "noOfCertificatesIssued": 20,
                "totalNoOfCertificates": 401,
                "issuedLocation": "Ahmedabad"
            }
        ]
}